<template>
	<div class="intro">
		<Corridor class="intro__content">
			<img src="@/assets/logo.svg" alt="COEX logo" />
			<div>
				<h1>How much cash is in your containers?</h1>
				<p>
					Use the Recyculator to estimate how much your eligible containers
					could be earning you each year.
				</p>
			</div>
			<Button @click="next">Get started</Button>
		</Corridor>
	</div>
</template>

<script>
import Corridor from '@/layouts/Corridor'
import Button from '@/components/Button'

export default {
	name: 'Intro',
	methods: {
		next() {
			this.$router.push('/calculator')
		}
	},
	components: {
		Corridor,
		Button
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/mq';

.intro {
	position: relative;
	height: 100%;
	background: linear-gradient(to bottom, $green-33, $green-44);

	&__content {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		text-align: center;
		padding: 1rem;
		color: white;

		@include mq(xs) {
			padding: 3rem 1.5rem;
		}
	}
}
</style>
